<template>
  <div class="common-card">
    <div
      v-report="{
        id: 'button',
        params: {
          type: 'personal_page',
          ...publicReport,
        },
      }"
      class="common-card-item"
      @click.stop="toPersonalPage"
    >
      <img
        :src="PersonalCenter"
        alt="personal-center"
      >
      <span>个人中心</span>
    </div>
    <div
      v-if="!isFamilySub"
      v-report="{
        id: 'button',
        params: {
          type: 'follow',
          ...publicReport,
        },
      }"
      class="common-card-item"
      @click.stop="toMyFocus"
    >
      <img
        :src="MyFocus"
        alt="focus"
      >
      <span>我的关注</span>
    </div>
    <div
      v-report="{
        id: 'button',
        params: {
          type: 'subscribe',
          ...publicReport,
        },
      }"
      class="common-card-item"
      @click.stop="toAppend"
    >
      <img
        :src="AddList"
        alt="add-list"
      >
      <span>我的加追</span>
    </div>
    <div class="split-line" />
    <div
      class="logout"
      :style="{
        justifyContent: showSwitchFVipRole ? 'space-between' : 'center',
      }"
    >
      <div
        v-if="showSwitchFVipRole"
        v-report="{
          id: 'button',
          params: {
            type: 'change_account',
            ...publicReport,
          },
        }"
        class="logout-check"
        :style="{
          paddingLeft: '26px',
        }"
        @click.stop="switchFVipRole"
      >
        <span>切换身份</span>
      </div>
      <div
        v-report="{
          id: 'button',
          params: {
            type: 'logout',
            ...publicReport,
          },
        }"
        class="logout-out"
        :style="{
          paddingLeft: showSwitchFVipRole ? '50px' : '38px',
        }"
        @click.stop="handleLogout"
      >
        <span>退出账号</span>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, ref, watch } from 'vue';
import PersonalCenter from '@/assets/svg/person-center.svg';
import MyFocus from '@/assets/svg/focus.svg';
import AddList from '@/assets/svg/add-list.svg';
import { useLoginStore } from '@/store';
import { onLoginReady } from '@/composables/useOnLoginReady';
import { logout } from '@common/logic';

const isEvo = import.meta.env.EVO;

const loginStore = useLoginStore();
const publicReport = computed(() => loginStore.publicReport);
const isFamilySub = computed(() => loginStore.isFamilySub);
const enableFVipSwitch = ref(false);
const _isFVip = computed(() => loginStore.userModule?.isFVip || false);
const showSwitchFVipRole = computed(() => (_isFVip.value && isEvo)
  || (_isFVip.value && !isEvo && enableFVipSwitch.value));

onLoginReady(
  () => {
    if (isEvo) return;
    watch(
      () => loginStore.loginInfo.vuserid,
      // web端需要判断登录组件是否启用了FVIP切换相关功能，可以通过查询FVIP状态来判断。
      () => enableFVipSwitch.value = window.txv.login.isSubRoleLogin() || window.txv.login.isMainRoleLogin(),
      { immediate: true },
    );
  },
);

const handleLogout = () => {
  console.info('[nav-login-panel] handleLogout');

  if (isEvo) {
    logout();
    return;
  };
  window.txv.login.logout({
    showConfirmDialog: true,
  });
};

const switchFVipRole = () => {
  if (isEvo) {
    vnContext.external.openQQLive('qqlive://sso/login=1&parent=main&switchRole=1');
    return;
  };
  window.txv.login.openFvipRoleDialog();
};

const personalPageUrl = 'https://v.qq.com/s/videoplus/host';
const toPersonalPage = () => {
  const { loginInfo } = loginStore;
  if (!isEvo) {
    window.open(personalPageUrl);
    return;
  }
  const type = loginInfo.vuserid ? 'vuserid' : 'vcuid';
  const accountId = loginInfo.vuserid ? loginInfo.vuserid : loginInfo.vcuid;
  // 打开外部浏览器
  // @ts-ignore
  vnContext.external.openQQLive(`qqlive://openAccountPage/accountId=${accountId}&type=${type}`);
};

const toMyFocus = () => {
  console.info('[nav-login-panel] toMyFocus');
  if (isEvo) {
    vnContext.external.openQQLive('qqlive://openchannel/tab=subscription');
    return;
  }
  window.open('https://v.qq.com/biu/u/binge?selectTab=focus_on&subTabId=0');
};

const toAppend = () => {
  console.info('[nav-login-panel] toAppend');
  if (isEvo) {
    vnContext.external.openQQLive('qqlive://openchannel/tab=chasing');
    return;
  }
  window.open('https://v.qq.com/biu/u/binge?selectTab=append&subTabId=0');
};

</script>

<style lang="scss" scoped>
.common-card {
  flex-shrink: 0;
  padding: 24px 16px;
  .common-card-item {
    display: flex;
    margin-bottom: 24px;
    cursor: pointer;
    img {
      width: 24px;
      height: 24px;
      margin-right: 16px;
    }
    span {
      font-size: 16px;
      font-weight: 400;
      color: #fff;
    }
  }
  .split-line {
    width: 100%;
    height: 1px;
    background-color: #fff;
    opacity: 0.2;
    margin-bottom: 24px;
  }
  .logout {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 280px;
    height: 24px;
    font-size: 16px;
    font-weight: 400;
    color: #fff;
    .logout-check,
    .logout-out {
      width: 140px;
      opacity: 0.6;
      cursor: pointer;
    }
    .logout-check:hover,
    .logout-out:hover {
      opacity: 1;
    }
  }
}
</style>
